// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/session_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bffuser/v1/session_model.proto.
 */
export const file_bffuser_v1_session_model: GenFile = /*@__PURE__*/
  fileDesc("Ch5iZmZ1c2VyL3YxL3Nlc3Npb25fbW9kZWwucHJvdG8SCmJmZnVzZXIudjEqhAEKFE9yZ2FuaXphdGlvbkxhbmd1YWdlEiUKIU9SR0FOSVpBVElPTl9MQU5HVUFHRV9VTlNQRUNJRklFRBAAEiIKHk9SR0FOSVpBVElPTl9MQU5HVUFHRV9KQVBBTkVTRRABEiEKHU9SR0FOSVpBVElPTl9MQU5HVUFHRV9FTkdMSVNIEAIqcAoPRGlzcGxheUxhbmd1YWdlEiAKHERJU1BMQVlfTEFOR1VBR0VfVU5TUEVDSUZJRUQQABIdChlESVNQTEFZX0xBTkdVQUdFX0pBUEFORVNFEAESHAoYRElTUExBWV9MQU5HVUFHRV9FTkdMSVNIEAJCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw");

/**
 * OrganizationLanguage is the display language configured at the organisation
 * level. The value is sourced from eAuth and forwarded by the BFF handler.
 * This is an ebalance-local enum distinct from eauth.v1.OrganizationLanguage
 * (which uses different value names without enum prefix). The backend
 * SessionService.GetSession converts between the two representations.
 *
 * @generated from enum bffuser.v1.OrganizationLanguage
 */
export enum OrganizationLanguage {
  /**
   * @generated from enum value: ORGANIZATION_LANGUAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORGANIZATION_LANGUAGE_JAPANESE = 1;
   */
  JAPANESE = 1,

  /**
   * @generated from enum value: ORGANIZATION_LANGUAGE_ENGLISH = 2;
   */
  ENGLISH = 2,
}

/**
 * Describes the enum bffuser.v1.OrganizationLanguage.
 */
export const OrganizationLanguageSchema: GenEnum<OrganizationLanguage> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_session_model, 0);

/**
 * DisplayLanguage is the language the logged-in member sees eBalance in
 * (UI text and language-dependent CSV output), resolved by the backend from
 * the member's eCloud personal setting with the organisation language as
 * fallback (spec settings/personal-settings.md section 2, AC-SPS-030).
 * UNSPECIFIED means "could not be determined": the frontend must keep its
 * current language rather than defaulting to Japanese.
 * Wire values mirror internalapi.v1.DisplayLanguage.
 *
 * @generated from enum bffuser.v1.DisplayLanguage
 */
export enum DisplayLanguage {
  /**
   * @generated from enum value: DISPLAY_LANGUAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DISPLAY_LANGUAGE_JAPANESE = 1;
   */
  JAPANESE = 1,

  /**
   * @generated from enum value: DISPLAY_LANGUAGE_ENGLISH = 2;
   */
  ENGLISH = 2,
}

/**
 * Describes the enum bffuser.v1.DisplayLanguage.
 */
export const DisplayLanguageSchema: GenEnum<DisplayLanguage> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_session_model, 1);

